import { hasAnalyticsConsent } from '../frontend/consent';

export type ConsentMode = 'strict' | 'analytics' | 'none';

export function canSendObservability(mode: ConsentMode): boolean {
  if (mode === 'none') return false;
  if (mode === 'strict') return true;
  if (typeof window === 'undefined') return true;
  const consent = window.localStorage.getItem('sazeo-marketing-cookie-consent');
  if (!consent) return true;
  return hasAnalyticsConsent();
}
